import { useInfiniteQuery } from "@tanstack/react-query";
import { listAggregatedThreads } from "../lib/api-client";
import { aggregateQueryKeys } from "../lib/query-keys";

/** "All Inboxes" cross-mailbox view — see MailboxSwitcher / AggregateThreadList. Only meaningful (and only ever enabled by callers) when the current user has access to more than one mailbox. */
export function useAggregatedThreads(folderSlug: string, enabled: boolean) {
  return useInfiniteQuery({
    queryKey: aggregateQueryKeys.threads(folderSlug),
    queryFn: ({ pageParam }) => listAggregatedThreads(folderSlug, pageParam),
    initialPageParam: null as string | null,
    getNextPageParam: (lastPage) => lastPage.nextCursor,
    enabled,
    staleTime: 15_000,
  });
}
